import { COMMENT_BOX_CANCELLED, COMMENT_BOX_OPENED } from '../../components/CommentsBox/types';

const initialState = false;

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case COMMENT_BOX_CANCELLED:
            return true;
        case COMMENT_BOX_OPENED:
            return false;
        default:
            return state;
    }
}
